var AssignmentItem = /** @class */ (function () {
    function AssignmentItem() {
        this.name = "";
        this.dateAssigned = null;
        this.type = "Assessment";
    }
    Object.defineProperty(AssignmentItem.prototype, "Id", {
        get: function () {
            return this.id;
        },
        set: function (v) {
            this.id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentItem.prototype, "Name", {
        get: function () {
            return this.name;
        },
        set: function (v) {
            this.name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentItem.prototype, "DateAssigned", {
        get: function () {
            return this.dateAssigned;
        },
        set: function (v) {
            this.dateAssigned = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentItem.prototype, "DateCompleted", {
        get: function () {
            return this.dateCompleted;
        },
        set: function (v) {
            this.dateCompleted = v;
        },
        enumerable: true,
        configurable: true
    });
    AssignmentItem.prototype.setDateAssigned = function (time) {
        this.DateAssigned = new Date(time);
        return this.DateAssigned;
    };
    Object.defineProperty(AssignmentItem.prototype, "IsComplete", {
        get: function () {
            return this.dateCompleted != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentItem.prototype, "Type", {
        get: function () {
            return this.type;
        },
        set: function (v) {
            this.type = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentItem.prototype, "ResultId", {
        get: function () {
            return this.resultId;
        },
        set: function (v) {
            this.resultId = v;
            if (v !== null) {
                this.DateCompleted = new Date();
            }
        },
        enumerable: true,
        configurable: true
    });
    return AssignmentItem;
}());
export { AssignmentItem };



// WEBPACK FOOTER //
// ./src/app/shared/models/AssignmentItem.ts.pre-build-optimizer.js